import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Button, ThemeProvider, AppBar, Toolbar, Box, SwipeableDrawer } from "@material-ui/core";
import { Panel } from "../";
import { FormattedMessage } from "react-intl";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { useStyles, expandedFooterTheme, minimizedFooterTheme } from "./styles";
import clsx from "clsx";
import { useCalculation } from "@ploy-lib/calculation";
import { getIn, useFormikContext } from "formik";
import { getFieldName } from "@ploy-lib/core";
export const StickyFooter = (props) => {
    const { innerRef, stickyFooter, stickyFooterExpanded } = props;
    const [expanded, setExpanded] = useState(false);
    const classes = useStyles(props);
    const formik = useFormikContext();
    const { errors } = useCalculation("errors");
    const canExpand = stickyFooterExpanded &&
        stickyFooterExpanded.sections &&
        stickyFooterExpanded.sections.length > 0;
    if ((stickyFooter &&
        stickyFooter.sections &&
        stickyFooter.sections.length === 0 &&
        !canExpand) ||
        (!canExpand && !stickyFooter)) {
        return null;
    }
    const onSave = () => {
        for (let section of stickyFooterExpanded.sections) {
            for (let field of section.fields) {
                const name = getFieldName(field);
                formik.setFieldTouched(name, true);
                if (getIn(errors, name)) {
                    return;
                }
            }
        }
        setExpanded(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(AppBar, { className: clsx(classes.root, classes.appBarBottom), elevation: stickyFooter && stickyFooter.elevation, square: stickyFooter && stickyFooter.square, position: "fixed", color: "inherit", id: "stickyFooterContainerMinimized", ref: innerRef, children: _jsxs(Toolbar, { children: [canExpand && (_jsx(Box, { children: _jsx(Button, { classes: {
                                    label: classes.openButtonLabel,
                                    endIcon: classes.openButtonEndIcon,
                                    text: classes.openButtonText
                                }, color: "primary", onClick: () => setExpanded(true), endIcon: _jsx(ExpandLessIcon, {}), children: _jsx(FormattedMessage, { id: "sticky-footer.show-details-button", defaultMessage: "Make changes" }) }) })), _jsx(Box, { flexGrow: [1, 1, 0] }), _jsx(Box, { p: 1, flexGrow: 1, children: stickyFooter && (_jsx(ThemeProvider, { theme: minimizedFooterTheme, children: _jsx(Panel, { ...stickyFooter, transparent: true }) })) })] }) }), canExpand && (_jsxs(SwipeableDrawer, { PaperProps: {
                    elevation: stickyFooterExpanded && stickyFooterExpanded.elevation,
                    square: stickyFooterExpanded && stickyFooterExpanded.square
                }, classes: {
                    paper: clsx(classes.root)
                }, anchor: "bottom", open: expanded, onClose: onSave, onOpen: () => setExpanded(true), disableSwipeToOpen: true, children: [_jsx(AppBar, { className: classes.appBarHeader, position: "static", color: "inherit", children: _jsx(Toolbar, { className: classes.saveButton, children: _jsx(Button, { onClick: onSave, children: _jsx(FormattedMessage, { id: "sticky-footer-expanded.summary-header.close", description: "Label close button", defaultMessage: "Close" }) }) }) }), stickyFooterExpanded && (_jsx(ThemeProvider, { theme: expandedFooterTheme, children: _jsx(Panel, { ...stickyFooterExpanded, transparent: true }) }))] }))] }));
};
//# sourceMappingURL=StickyFooter.js.map